import axios from "axios";

const BASE_URL_LIVE = process.env.REACT_APP_BASE_URL_LIVE;
const BASE_URL_TEST = process.env.REACT_APP_BASE_URL_TEST;

const instance = axios.create({
  baseURL: BASE_URL_LIVE,
});

export default instance;
